import { createContext } from 'react';

export const WorkspaceResourcesContext = createContext({} as any);
